import CombinedProvider from 'injection/CombinedProvider';

/* global actionsProvider */

class ActionsProvider {
  getActions(actionsName) {
    const result = CombinedProvider.get(actionsName);
    if (!result[`${actionsName}Actions`]) {
      throw new Error(`Requested actions "${actionsName}" is not registered.`);
    }
    return result[`${actionsName}Actions`];
  }
}

if (typeof actionsProvider === 'undefined') {
  window.actionsProvider = new ActionsProvider();
}

export default actionsProvider;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/injection/ActionsProvider.jsx